export default __webpack_public_path__ + "static/data-driven-4bafa453be52c12bae3c601d4c65da7b.svg";